var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createMuiTheme } from '@ncr-design-system/test-shared';
import { common } from '@material-ui/core/colors';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
var COLORS = {
    alto: '#dbdbdb',
    dodgerBlue: '#5565FD',
    veryLightBlue: '#6F7FFF',
    melrose: '#A2B2FF',
    tuna: '#3C3C43',
    tooltipGrey: '#616161E6',
    border: '3c3c4421',
    tableBorder: '#3C3C4321',
    tunaLight: '#3c3c434d',
    disabledInputsPlaceholder: '#9d9d9d',
};
var defaultMuiTheme = createMuiTheme({
    color: {
        type: 'light',
        primary: {
            main: COLORS.dodgerBlue,
        },
        secondary: {
            main: COLORS.veryLightBlue,
        },
    },
}, {
    spacing: 8,
});
defaultMuiTheme.shape = {
    borderRadius: 4,
};
defaultMuiTheme.palette = __assign(__assign({}, defaultMuiTheme.palette), { text: __assign(__assign({}, defaultMuiTheme.palette.text), { primary: common.black, secondary: COLORS.tuna }), background: __assign(__assign({}, defaultMuiTheme.palette.background), { tooltip: COLORS.tooltipGrey, tertiary: COLORS.alto }), custom: __assign(__assign({}, defaultMuiTheme.palette.custom), { border: COLORS.border, tableBorder: COLORS.tableBorder, disabledInputsPlaceholder: COLORS.disabledInputsPlaceholder }), fill: {
        primary: COLORS.dodgerBlue,
        secondary: COLORS.dodgerBlue,
        tertiary: COLORS.dodgerBlue,
        quaternary: COLORS.melrose,
    } });
defaultMuiTheme.overrides = {
    MuiIcon: {
        colorSecondary: {
            color: COLORS.dodgerBlue,
        },
    },
    MuiButton: {
        root: {
            minHeight: '40px',
        },
    },
    MuiTable: {
        root: {
            marginTop: defaultMuiTheme.spacing(3),
            background: defaultMuiTheme.palette.common.white,
            borderRadius: '8px',
        },
    },
    MuiTableCell: {
        stickyHeader: {
            backgroundColor: defaultMuiTheme.palette.common.white,
        },
        root: {
            borderBottom: "1px solid " + defaultMuiTheme.palette.custom.tableBorder,
            padding: defaultMuiTheme.spacing(2),
            '&.action-cell': {
                padding: defaultMuiTheme.spacing(0, 0.5, 0, 0),
            },
            '& .action-button': {
                padding: defaultMuiTheme.spacing(2.25, 1.5),
                borderRadius: 0,
                height: '100%',
            },
            '& .Mui-error': {
                position: 'absolute',
                bottom: 0,
                '& .MuiFormHelperText-root': {
                    fontSize: '12px',
                    lineHeight: '16px',
                },
                '& + .MuiFormHelperText-root': {
                    left: 0,
                },
            },
            '& .MuiGrid-container': {
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            },
        },
        head: {
            fontWeight: 500,
            '&:hover, &:hover > svg': {
                color: defaultMuiTheme.palette.primary.main,
            },
        },
    },
    MuiTableRow: {
        head: {
            borderRadius: '8px',
        },
        root: {
            '& .MuiFormControl-root': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            },
            '&:last-of-type td': {
                border: 0,
            },
            '&.form-row.edit ': {
                '& td.not-editable': {
                    padding: defaultMuiTheme.spacing(2),
                    alignItems: 'center',
                },
            },
            '&.form-row ': {
                '& label.MuiInputLabel-formControl': {
                    display: 'none',
                },
                '& .MuiInputBase-root': {
                    border: 0,
                    borderRadius: 0,
                },
                '& input, & .MuiInputBase-root, & .MuiAutocomplete-root, & [class*="multiValuePicker"] ': {
                    width: '100%',
                    height: '100%',
                },
                '& td': {
                    padding: 0,
                    verticalAlign: 'top',
                    height: '64px',
                },
                '& td.action-cell': {
                    paddingRight: defaultMuiTheme.spacing(0.5),
                },
            },
            '& [class*="wrapper"], & [class*="groupNameField"], & [class*="reasonNameField"], & [class*="dateField"]': {
                margin: 0,
                height: '100%',
            },
        },
    },
    MuiTableSortLabel: {
        root: {
            '& svg': {
                fontSize: '24px',
                marginLeft: defaultMuiTheme.spacing(1.5),
                color: defaultMuiTheme.palette.action.active,
            },
            '&:hover, &:hover svg': {
                color: defaultMuiTheme.palette.primary.main,
            },
        },
    },
};
defaultMuiTheme.props = {
    MuiCheckbox: {
        icon: _jsx(CheckBoxOutlineBlankIcon, {}, void 0),
        checkedIcon: _jsx(CheckBoxIcon, {}, void 0),
        indeterminateIcon: _jsx(IndeterminateCheckBoxIcon, {}, void 0),
    },
    MuiRadio: {
        icon: _jsx(RadioButtonUncheckedIcon, {}, void 0),
        checkedIcon: _jsx(RadioButtonCheckedIcon, {}, void 0),
    },
};
export { defaultMuiTheme, COLORS };
